<div class="h-full w-full bg-gray-100 flex flex-col overflow-hidden">
  <!-- Header -->
  <div
    class="flex flex-col md:flex-row md:items-center items-start px-6 py-4 z-40 gap-4 md:justify-between bg-white shadow rounded-b-2xl"
  >
    <img [src]="headerLogo" [attr.alt]="'domainSubscription.logoAlt' | translate" class="h-24 md:h-28" />

    <div class="flex flex-col md:flex-row gap-4">
      <div
        class="flex gap-2 text-primary items-center px-5 py-2 bg-gray-50 rounded-xl shadow-sm"
      >
        <img src="../../assets/image/call.svg" alt="" class="hidden md:block" />
        <span class="font-medium">{{ supportContactNumber }}</span>
      </div>
      <div
        class="flex gap-2 text-primary items-center px-5 py-2 bg-gray-50 rounded-xl shadow-sm"
      >
        <img
          src="../../assets/image/Shape.svg"
          alt=""
          class="hidden md:block"
        />
        <span class="font-medium">{{ supportContactEmail }}</span>
      </div>
    </div>
  </div>

  <!-- Main Section -->
  <div class="flex flex-col lg:flex-row gap-6 p-2 overflow-auto">
    <!-- Left Column: Subscription Form -->
    <div
      class="flex flex-col bg-white rounded-2xl shadow-md p-2 space-y-8 flex-1"
    >
      <h2 class="text-2xl font-bold text-gray-800  mb-0">
        {{ 'domainSubscription.title' | translate }}
      </h2>

      <!-- Domain Selection -->
      <section class="mb-2">
        <label class="block font-semibold text-lg mb-4 text-gray-700"
          >{{ 'domainSubscription.chooseDomains' | translate }}</label
        >
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          <div
            *ngFor="let domain of domains"
            class="cursor-pointer border rounded-xl p-4 text-center transition-all bg-gray-50 hover:bg-blue-50 shadow-sm"
            [ngClass]="{
              'ring-2 ring-blue-500 bg-blue-100 shadow-md':
                selectedDomains.includes(domain.name)
            }"
            (click)="
              onDomainChange({
                target: {
                  value: domain.name,
                  checked: !selectedDomains.includes(domain.name)
                }
              })
            "
          >
            <h3 class="font-semibold text-gray-800">{{ domain.name }}</h3>
          </div>
        </div>
      </section>

      <!-- Subscription Form -->
      <form
        [formGroup]="form"
        (ngSubmit)="calculateTotal()"
        class="space-y-6 overflow-auto"
      >
        <!-- General Info -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label class="block mb-2 text-sm font-semibold text-gray-700"
              >{{ 'domainSubscription.organizationId' | translate }}</label
            >
            <input
              formControlName="organization_code"
              type="text"
              readonly
              
              class="w-full px-2 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
          </div>

          <div>
            <label
              for="duration"
              class="block mb-2 text-sm font-semibold text-gray-700"
              >{{ 'domainSubscription.durationMonths' | translate }}</label
            >
            <select
              formControlName="duration"
              id="duration"
              class="w-full px-2 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
            >
            <option value="0">{{ 'domainSubscription.selectMonth' | translate }}</option>
              <option *ngFor="let month of monthOptions" [value]="month">
                {{ month > 1 ? ('domainSubscription.monthPlural' | translate: { count: month }) : ('domainSubscription.monthSingular' | translate: { count: month }) }}
              </option>
            </select>
          </div>
        </div>

        <!-- Dynamic Domain Sections -->
        <ng-container
          *ngFor="
            let domain of [
              'Consultancy',
              'Road',
              'Construction',
              'Utilities'
            ]
          "
        >
          <div
            *ngIf="selectedDomains.includes(domain)"
            [formGroupName]="domain"
            class="mt-4 p-2 border rounded-xl bg-gray-50 shadow-sm"
          >
            <h3 class="text-lg font-bold text-blue-700 mb-4">
              {{ 'domainSubscription.domainDetails' | translate: { domain: domain } }}
            </h3>

            <div
              class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 overflow-auto"
            >
              <ng-container [ngSwitch]="domain">
                <ng-container *ngSwitchCase="'Consultancy'">
                  <div *ngIf="false">
                    <label class="block mb-1 text-sm font-medium text-gray-700"
                      >{{ 'domainSubscription.projectsPerMonth' | translate }}</label
                    >
                    <input
                      formControlName="projects"
                      type="number"
                      [attr.placeholder]="'domainSubscription.projectsPerMonthPlaceholder' | translate"
                      class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div >
                    <label class="block mb-1 text-sm font-medium text-gray-700"
                      >{{ 'domainSubscription.users' | translate }}</label
                    >
                    <input
                      formControlName="users_count"
                      type="number"
                      [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                      class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'Road'">
                  <div *ngIf="false">
                    <label class="block mb-1 text-sm font-medium text-gray-700"
                      >{{ 'domainSubscription.lengthKm' | translate }}</label
                    >
                    <input
                      formControlName="length"
                      type="number"
                      [attr.placeholder]="'domainSubscription.lengthPlaceholder' | translate"
                      class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div *ngIf="false">
                    <label class="block mb-1 text-sm font-medium text-gray-700"
                      >{{ 'domainSubscription.lanes' | translate }}</label
                    >
                    <input
                      formControlName="lanes"
                      type="number"
                      [attr.placeholder]="'domainSubscription.lanesPlaceholder' | translate"
                      class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                  <div>
                    <label class="block mb-1 text-sm font-medium text-gray-700"
                      >{{ 'domainSubscription.users' | translate }}</label
                    >
                    <input
                      formControlName="users_count"
                      type="number"
                      [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                      class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                    />
                  </div>
                </ng-container>
                <ng-container *ngSwitchCase="'Construction'">
                  <div *ngIf="false">
                    
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.areaSqm' | translate }}</label
                        >
                        <input
                          formControlName="area"
                          type="number"
                          [attr.placeholder]="'domainSubscription.areaPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                      <div >
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.numberOfUsers' | translate }}</label
                        >
                        <input
                          formControlName="users_count"
                          type="number"
                          [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                </ng-container>
                <!-- <ng-container *ngSwitchCase="'Residential'">
                  <div>
                  
                          <label
                            class="block mb-1 text-sm font-medium text-gray-700"
                            >{{ 'domainSubscription.areaSqm' | translate }}</label
                          >
                          <input
                            formControlName="area"
                            type="number"
                            [attr.placeholder]="'domainSubscription.areaPlaceholder' | translate"
                            class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                          />
                        </div>
                        <div >
                          <label
                            class="block mb-1 text-sm font-medium text-gray-700"
                            >{{ 'domainSubscription.numberOfUsers' | translate }}</label
                          >
                          <input
                            formControlName="users_count"
                            type="number"
                            [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                            class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                          />
                        </div>
                </ng-container> -->

                <ng-container *ngSwitchCase="'Utilities'">
                  <div *ngIf="false">
                   
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.lengthMeters' | translate }}</label
                        >
                        <input
                          formControlName="length"
                          type="number"
                          [attr.placeholder]="'domainSubscription.lengthMetersPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                      <div >
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.numberOfUsers' | translate }}</label
                        >
                        <input
                          formControlName="users_count"
                          type="number"
                          [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                   
                </ng-container>
                <!-- <ng-container *ngSwitchCase="'Education'">
                  <div>
                   
                          <label
                            class="block mb-1 text-sm font-medium text-gray-700"
                            >{{ 'domainSubscription.areaSqm' | translate }}</label
                          >
                          <input
                            formControlName="area"
                            type="number"
                            [attr.placeholder]="'domainSubscription.areaPlaceholder' | translate"
                            class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                          />
                        </div>
                        <div >
                          <label
                            class="block mb-1 text-sm font-medium text-gray-700"
                            >{{ 'domainSubscription.numberOfUsers' | translate }}</label
                          >
                          <input
                            formControlName="users_count"
                            type="number"
                            [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                            class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                          />
                        </div>
                     
                </ng-container> 

                <ng-container *ngSwitchCase="'Telecom'">
                  <div>
                  
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.lengthMeters' | translate }}</label
                        >
                        <input
                          formControlName="length"
                          type="number"
                          [attr.placeholder]="'domainSubscription.lengthMetersPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                      <div >
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.numberOfUsers' | translate }}</label
                        >
                        <input
                          formControlName="users_count"
                          type="number"
                          [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
               
                </ng-container>
                <ng-container *ngSwitchCase="'Electric'">
                  <div>
                   
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.lengthMeters' | translate }}</label
                        >
                        <input
                          formControlName="length"
                          type="number"
                          [attr.placeholder]="'domainSubscription.lengthMetersPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                      <div >
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.numberOfUsers' | translate }}</label
                        >
                        <input
                          formControlName="users_count"
                          type="number"
                          [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                  
                </ng-container>
                <ng-container *ngSwitchCase="'Gas'">
                  <div>
                    
                 
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.lengthMeters' | translate }}</label
                        >
                        <input
                          formControlName="length"
                          type="number"
                          [attr.placeholder]="'domainSubscription.lengthMetersPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                      <div >
                        <label
                          class="block mb-1 text-sm font-medium text-gray-700"
                          >{{ 'domainSubscription.numberOfUsers' | translate }}</label
                        >
                        <input
                          formControlName="users_count"
                          type="number"
                          [attr.placeholder]="'domainSubscription.usersCountPlaceholder' | translate"
                          class="w-full px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                        />
                      </div>
                   
                </ng-container> -->
              </ng-container>
            </div>
          </div>
        </ng-container>

        <!-- Submit -->
        <button
          type="submit"
          class="w-full py-3 bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-semibold rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-300 shadow-lg"
        >
          {{ 'domainSubscription.calculateSubscription' | translate }}
        </button>
      </form>
    </div>

    <!-- Right Column: Total & Payment -->
    <div
      class="w-full lg:w-1/3 bg-white rounded-2xl shadow-md p-4 flex flex-col justify-between"
    >
      <div *ngIf="totalAmount" class="mb-6">
        <!-- Calculation Breakup -->
        <div class="mb-4 space-y-3">
          <div class="flex justify-between items-center text-gray-700">
            <span class="text-sm font-medium">{{ 'domainSubscription.subtotal' | translate }}</span>
            <span class="text-sm font-semibold">₹{{ subtotal | number:'1.2-2' }}</span>
          </div>
          <div class="flex justify-between items-center text-gray-700">
            <span class="text-sm font-medium">{{ 'domainSubscription.gst' | translate }}</span>
            <span class="text-sm font-semibold">₹{{ gstAmount | number:'1.2-2' }}</span>
          </div>
          <div class="border-t pt-3 mt-3">
            <div class="flex justify-between items-center">
              <span class="text-lg font-bold text-gray-800">{{ 'domainSubscription.orderTotal' | translate }}</span>
              <span class="text-xl font-bold text-green-600">₹{{ orderTotal | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Payment Gateway Selection -->
      <div *ngIf="false" class="mb-4">
        <label class="block text-sm font-semibold text-gray-700 mb-2">{{ 'domainSubscription.paymentGateway' | translate }}</label>
        <div class="flex gap-4">
          <label class="flex items-center cursor-pointer">
            <input
              type="radio"
              name="paymentGateway"
              value="stripe"
              [(ngModel)]="paymentGateway"
              class="mr-2"
            />
            <span class="text-sm">{{ 'domainSubscription.stripe' | translate }}</span>
          </label>
          <label class="flex items-center cursor-pointer">
            <input
              type="radio"
              name="paymentGateway"
              value="razorpay"
              [(ngModel)]="paymentGateway"
              class="mr-2"
            />
            <span class="text-sm">{{ 'domainSubscription.razorpay' | translate }}</span>
          </label>
        </div>
      </div>

      <button
        type="button"
        class="w-full py-3 bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold rounded-lg hover:from-green-600 hover:to-emerald-700 transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
        (click)="proceedToPay()"
        [disabled]="!totalAmount || totalAmount === 0 || loading"
      >
        <span *ngIf="!loading">{{ 'domainSubscription.proceedToPay' | translate }}</span>
        <span *ngIf="loading">{{ 'domainSubscription.processing' | translate }}</span>
      </button>
    </div>
  </div>
</div>
